import { Component, Input } from '@angular/core';

import { FetchProfileImageDirective } from '@shared/directives';
import { TranslateModule } from '@ngx-translate/core';
import { CourseUser, UserEntity } from '@core/entities';
import { BadgeComponent } from '@shared/components/ui';
import { isMobileView } from '@core/utils';
import { ApprovedStatus } from '@core/enums';

@Component({
  selector: 'app-course-participants',
  imports: [TranslateModule, BadgeComponent, FetchProfileImageDirective],
  templateUrl: './course-participants.component.html',
  styleUrls: ['./course-participants.component.scss'],
})
export class CourseParticipantsComponent {
  @Input() unapprovedParticipants: UserEntity[] = [];
  @Input() approvedParticipants: CourseUser[] = [];
  @Input() organizer: UserEntity;
  protected readonly isMobileView = isMobileView();

  getApprovedText(user: CourseUser): string {
    switch (user?.approvedStatus) {
      case ApprovedStatus.Approved:
        return 'Approved';
      case ApprovedStatus.Pending:
        return 'Pending';
      case ApprovedStatus.Rejected:
        return 'courses.rejected';
      case ApprovedStatus.UnAccepted:
        return 'Pending';
      default:
        return 'Pending';
    }
  }

  getBadgeColor(user: CourseUser): 'success' | 'warning' | 'danger' | 'info' | 'primary' | 'secondary' | 'gradient' {
    switch (user?.approvedStatus) {
      case ApprovedStatus.Approved:
        return 'success';
      case ApprovedStatus.Pending:
        return 'info';
      case ApprovedStatus.Rejected:
        return 'primary';
      case ApprovedStatus.UnAccepted:
        return 'primary';
      default:
        return 'info';
    }
  }
}
